import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { ComponentTranslationDto, NewGuidelineChapter } from '@treetop/shared/model';

import { ControlsOf } from './FormResolver';

export function registerTranslationControls(
  alternativeTranslations: ComponentTranslationDto[],
  component: FormGroup<ControlsOf<NewGuidelineChapter>>,
): void {
  alternativeTranslations.forEach(() => {
    (component.get('alternativeTranslations') as unknown as FormArray<FormGroup<ControlsOf<ComponentTranslationDto>>>)?.push(
      new FormGroup<ControlsOf<ComponentTranslationDto>>({
        languageCode: new FormControl<string | null>(null),
        title: new FormControl<string | null>(null),
        description: new FormControl<string | null>(null),
      }),
    );
  });
}
